<template>
  <div v-if="submissions">
    <div class="mb-6">
      <BookingFormSubmission
        :submission="selected"
        :active="isSidebarOpen"
        @update:active="isSidebarOpen = $event"
      />
    </div>

    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>Booking forms are shown for all venues.</p>
      </vs-col>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="100"
        :data="submissions"
        noDataText="No data"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Form</vs-th>
          <vs-th>Venue</vs-th>
          <vs-th>Guest name</vs-th>
          <vs-th>Time</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.bookingForm.formName }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  <vs-chip color="primary">{{
                    tr.venueName ? tr.venueName : "N/A"
                  }}</vs-chip>
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  <code>{{ tr.guestName ? tr.guestName : "N/A" }}</code>
                </p>
              </vs-td>

              <vs-td>
                <p class="product-category">
                  {{ tr.date | formatDate }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import BookingFormSubmission from "./BookingFormSubmission.vue";

export default {
  components: { BookingFormSubmission },
  data() {
    return {
      moment,
      isSidebarOpen: false,
      selected: null,
    };
  },
  methods: {
    onClicked(id) {
      this.isSidebarOpen = true;
    },
  },
  computed: {
    ...mapGetters({
      submissions: "bookingForms/submissions",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("bookingForms/getSubmissions");
    this.$vs.loading.close();
  },
};
</script>
